import { combineReducers } from 'redux';

export function error(state = null, action) {
  switch (action.type) {
    case 'LIVEINTERVIEW_SHARE_LINK_LIST_ERROR':
      return action.error;

    case 'LIVEINTERVIEW_SHARE_LINK_LIST_RESET':
      return null;

    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case 'LIVEINTERVIEW_SHARE_LINK_LIST_LOADING':
      return action.loading;

    case 'LIVEINTERVIEW_SHARE_LINK_LIST_RESET':
      return false;

    default:
      return state;
  }
}

export function retrieved(state = null, action) {
  switch (action.type) {
    case 'LIVEINTERVIEW_SHARE_LINK_LIST_SUCCESS':
      return action.retrieved;

    case 'LIVEINTERVIEW_SHARE_LINK_LIST_RESET':
      return null;

    default:
      return state;
  }
}

export function filtersData(state = null, action) {
  switch (action.type) {
    case 'LIVEINTERVIEW_SHARE_LINK_LIST_FILTER':
      return action.filtersData;

    case 'LIVEINTERVIEW_SHARE_LINK_LIST_RESET':
      return null;

    default:
      return state;
  }
}

export function sortData(state = null, action) {
  switch (action.type) {
    case 'LIVEINTERVIEW_SHARE_LINK_LIST_SORT':
      return action.sortData;

    default:
      return state;
  }
}

export default combineReducers({ error, loading, retrieved, filtersData, sortData });
